function findNearestScroller(startRef, axis = "vertical") {
  let currentElement = startRef instanceof HTMLElement ? startRef : startRef == null ? void 0 : startRef.current;
  while (currentElement) {
    if (currentElement === document.body) {
      return void 0;
    }
    const styles = window.getComputedStyle(currentElement);
    if (axis === "vertical" && ["auto", "scroll", "overlay"].includes(styles.overflowY) || axis === "horisontal" && ["auto", "scroll", "overlay"].includes(styles.overflowX)) {
      return currentElement;
    }
    currentElement = currentElement.parentElement;
  }
}

export { findNearestScroller };
//# sourceMappingURL=dom.find-nearest-scroller.js.map
